import { useState } from 'react'

const useModal = () => {
  //TODO: remove inecesary state
  const [isShowing, setIsShowing] = useState(false)
  const [isShowingEdit, setIsShowingEdit] = useState(false)
  const [isShowingAdd, setIsShowingAdd] = useState(false)
  const [isShowingInfo, setIsShowingInfo] = useState(false)

  const toggle = () => {
    setIsShowing(!isShowing)
  }

  const toggleEdit = () => {
    setIsShowingEdit(!isShowingEdit)
  }

  const toggleAdd = () => {
    setIsShowingAdd(!isShowingAdd)
  }

  const toggleInfo = () => {
    setIsShowingInfo(!isShowingInfo)
  }

  return {
    isShowing,
    isShowingEdit,
    toggle,
    toggleEdit,
    isShowingAdd,
    toggleAdd,
    isShowingInfo,
    toggleInfo,
  }
}

export default useModal
